import { render, staticRenderFns } from "./complain.vue?vue&type=template&id=7f1cde3e"
import script from "./complain.vue?vue&type=script&lang=js"
export * from "./complain.vue?vue&type=script&lang=js"
import style0 from "./complain.vue?vue&type=style&index=0&id=7f1cde3e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f1cde3e')) {
      api.createRecord('7f1cde3e', component.options)
    } else {
      api.reload('7f1cde3e', component.options)
    }
    module.hot.accept("./complain.vue?vue&type=template&id=7f1cde3e", function () {
      api.rerender('7f1cde3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/message/complain.vue"
export default component.exports